module.exports = {
	"name": "BPMNDI",
	"uri": "http://www.omg.org/spec/BPMN/20100524/DI",
	"types": [
		{
			"name": "BPMNDiagram",
			"properties": [
				{
					"name": "plane",
					"type": "BPMNPlane",
					"redefines": "di:Diagram#rootElement"
				},
				{
					"name": "labelStyle",
					"type": "BPMNLabelStyle",
					"isMany": true
				}
			],
			"superClass": [
				"di:Diagram"
			]
		},
		{
			"name": "BPMNPlane",
			"properties": [
				{
					"name": "bpmnElement",
					"isAttr": true,
					"isReference": true,
					"type": "bpmn:BaseElement",
					"redefines": "di:DiagramElement#modelElement"
				}
			],
			"superClass": [
				"di:Plane"
			]
		},
		{
			"name": "BPMNShape",
			"properties": [
				{
					"name": "bpmnElement",
					"isAttr": true,
					"isReference": true,
					"type": "bpmn:BaseElement",
					"redefines": "di:DiagramElement#modelElement"
				},
				{
					"name": "isHorizontal",
					"isAttr": true,
					"type": "Boolean"
				},
				{
					"name": "isExpanded",
					"isAttr": true,
					"type": "Boolean"
				},
				{
					"name": "isMarkerVisible",
					"isAttr": true,
					"type": "Boolean"
				},
				{
					"name": "label",
					"type": "BPMNLabel"
				},
				{
					"name": "isMessageVisible",
					"isAttr": true,
					"type": "Boolean"
				},
				{
					"name": "participantBandKind",
					"type": "ParticipantBandKind",
					"isAttr": true
				},
				{
					"name": "choreographyActivityShape",
					"type": "BPMNShape",
					"isAttr": true,
					"isReference": true
				}
			],
			"superClass": [
				"di:LabeledShape"
			]
		},
		{
			"name": "BPMNEdge",
			"properties": [
				{
					"name": "label",
					"type": "BPMNLabel"
				},
				{
					"name": "bpmnElement",
					"isAttr": true,
					"isReference": true,
					"type": "bpmn:BaseElement",
					"redefines": "di:DiagramElement#modelElement"
				},
				{
					"name": "sourceElement",
					"isAttr": true,
					"isReference": true,
					"type": "di:DiagramElement",
					"redefines": "di:Edge#source"
				},
				{
					"name": "targetElement",
					"isAttr": true,
					"isReference": true,
					"type": "di:DiagramElement",
					"redefines": "di:Edge#target"
				},
				{
					"name": "messageVisibleKind",
					"type": "MessageVisibleKind",
					"isAttr": true,
					"default": "initiating"
				}
			],
			"superClass": [
				"di:LabeledEdge"
			]
		},
		{
			"name": "BPMNLabel",
			"properties": [
				{
					"name": "labelStyle",
					"type": "BPMNLabelStyle",
					"isAttr": true,
					"isReference": true,
					"redefines": "di:DiagramElement#style"
				}
			],
			"superClass": [
				"di:Label"
			]
		},
		{
			"name": "BPMNLabelStyle",
			"properties": [
				{
					"name": "font",
					"type": "dc:Font"
				}
			],
			"superClass": [
				"di:Style"
			]
		}
	],
	"emumerations": [
		{
			"name": "ParticipantBandKind",
			"literalValues": [
				{
					"name": "top_initiating"
				},
				{
					"name": "middle_initiating"
				},
				{
					"name": "bottom_initiating"
				},
				{
					"name": "top_non_initiating"
				},
				{
					"name": "middle_non_initiating"
				},
				{
					"name": "bottom_non_initiating"
				}
			]
		},
		{
			"name": "MessageVisibleKind",
			"literalValues": [
				{
					"name": "initiating"
				},
				{
					"name": "non_initiating"
				}
			]
		}
	],
	"associations": [],
	"prefix": "bpmndi"
};


//////////////////
// WEBPACK FOOTER
// ./~/bpmn-moddle/resources/bpmn/json/bpmndi.json
// module id = 326
// module chunks = 0